(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fagaci-email-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.getElementById('fes-submit-btn');
  var input = document.getElementById('fes-email');
  var formRow = document.getElementById('fes-form-row');
  var success = document.getElementById('fes-success');

  if (!btn || !input) return;

  btn.addEventListener('click', function () {
    var emailValue = input.value.trim();

    if (!emailValue || emailValue.indexOf('@') === -1) {
      input.style.borderColor = 'rgba(217,97,62,0.7)';
      input.focus();
      return;
    }

    input.style.borderColor = '';
    btn.textContent = '...';
    btn.disabled = true;

    try {
      var omnisendContainer = document.getElementById('omnisend-embedded-v2-' + (window._fesOmnisendFormId || ''));
      if (!omnisendContainer) {
        omnisendContainer = document.querySelector('[id^="omnisend-embedded-v2-"]');
      }
      var omnisendInput = omnisendContainer ? omnisendContainer.querySelector('input[type="email"], input[name="email"]') : null;
      var omnisendSubmit = omnisendContainer ? omnisendContainer.querySelector('button[type="submit"], input[type="submit"]') : null;

      if (omnisendInput) {
        omnisendInput.value = emailValue;
        omnisendInput.dispatchEvent(new Event('input', { bubbles: true }));
        omnisendInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (omnisendSubmit) {
        omnisendSubmit.click();
      }

      setTimeout(function () {
        formRow.style.display = 'none';
        success.style.display = 'block';
      }, 1200);

    } catch (err) {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-label') || 'UNLOCK ACCESS';
      input.style.borderColor = 'rgba(217,97,62,0.7)';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ffq-question').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = this.closest('.ffq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.ffq-item.open').forEach(function(el) {
      el.classList.remove('open');
      el.querySelector('.ffq-question').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      this.setAttribute('aria-expanded', 'true');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-header"]) return;
  try {
    
(function() {

  /* ── Scroll-aware hide / show ── */
  (function () {
    var wrapper   = document.querySelector('.fagaci-header-wrapper');
    if (!wrapper) return;

    var lastY     = window.scrollY;
    var hidden    = false;
    var threshold = 80;   /* px scrolled before we start hiding */
    var ticking   = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var y     = window.scrollY;
          var delta = y - lastY;

          /* Don't hide if mobile drawer is open */
          var drawerOpen = document.getElementById('fgh-nav-drawer') &&
                           document.getElementById('fgh-nav-drawer').classList.contains('fgh-nav-drawer--open');

          if (y < threshold) {
            /* Near top — always show */
            if (hidden) { wrapper.classList.remove('fgh--hidden'); hidden = false; }
          } else if (delta > 4 && !drawerOpen) {
            /* Scrolling down */
            if (!hidden) { wrapper.classList.add('fgh--hidden'); hidden = true; }
          } else if (delta < -4) {
            /* Scrolling up */
            if (hidden) { wrapper.classList.remove('fgh--hidden'); hidden = false; }
          }

          lastY   = y;
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  var btn = document.querySelector('.fgh-nav-hamburger');
  var drawer = document.getElementById('fgh-nav-drawer');
  if (btn && drawer) {
    btn.addEventListener('click', function() {
      var isOpen = drawer.classList.toggle('fgh-nav-drawer--open');
      btn.classList.toggle('fgh-nav-hamburger--open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  var cartBtnDesktop = document.getElementById('fgh-cart-btn-desktop');
  var cartBtnMobile = document.getElementById('fgh-cart-btn-mobile');
  function openFagaciCart(e) {
    e.preventDefault();
    if (window.fagaciCart) window.fagaciCart.open();
  }
  if (cartBtnDesktop) cartBtnDesktop.addEventListener('click', openFagaciCart);
  if (cartBtnMobile) cartBtnMobile.addEventListener('click', openFagaciCart);

  function updateCartCount(count) {
    var bubbles = document.querySelectorAll('.fgh-nav-cart-count');
    bubbles.forEach(function(bubble) {
      if (count > 0) {
        bubble.textContent = count;
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function() {});
  }

  document.addEventListener('cart:update', fetchCartCount);

  fetchCartCount();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-our-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var elems = document.querySelectorAll('.fos-anim');
  if (!elems.length) return;

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fos-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    elems.forEach(function (el) { observer.observe(el); });
  } else {
    /* Fallback: show everything immediately */
    elems.forEach(function (el) { el.classList.add('fos-visible'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-product-content"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fpc-slider]').forEach(function(slider) {
  var wrap = slider.querySelector('.fpc-slider-track-wrap');
  var track = slider.querySelector('.fpc-slider-track');
  var slides = slider.querySelectorAll('.fpc-slide');
  var dots = slider.querySelectorAll('.fpc-dot');
  var total = slides.length;
  var current = 0;
  if (total <= 1) return;

  function slideWidth() {
    return wrap.offsetWidth;
  }

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)';
    dots.forEach(function(d, i) {
      d.classList.toggle('fpc-dot--active', i === current);
    });
  }

  /* Recalculate on resize so pixel offset stays accurate */
  window.addEventListener('resize', function() {
    track.style.transition = 'none';
    track.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)';
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        track.style.transition = '';
      });
    });
  });

  var prevBtn = slider.querySelector('.fpc-arrow--prev');
  var nextBtn = slider.querySelector('.fpc-arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  var startX = 0;
  slider.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });
  slider.addEventListener('touchend', function(e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-promo-banner"] && !Shopify.designMode) return;
  try {
    
(function() {

  // ── COUNTDOWN ──────────────────────────────────────────────
  var countdown = document.querySelector('.fpb-countdown[data-end]');
  if (countdown) {
    var endDate = new Date(countdown.dataset.end.replace(' ', 'T')).getTime();
    function tick() {
      var diff = Math.max(0, Math.floor((endDate - Date.now()) / 1000));
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
      countdown.querySelector('.fpb-days').textContent  = pad(d);
      countdown.querySelector('.fpb-hours').textContent = pad(h);
      countdown.querySelector('.fpb-mins').textContent  = pad(m);
      countdown.querySelector('.fpb-secs').textContent  = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  // ── APPLY + OPEN CART DRAWER ──────────────────────────────
  var copyBtn = document.querySelector('.fpb-copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      var code    = copyBtn.dataset.code;
      var btnText = copyBtn.querySelector('.fpb-copy-btn-text');

      // Pre-fill and expand the drawer's discount section regardless
      var drawerInput  = document.getElementById('fcd-discount-input');
      var drawerBody   = document.getElementById('fcd-discount-body');
      var drawerToggle = document.getElementById('fcd-discount-toggle');
      var drawerMsg    = document.getElementById('fcd-discount-msg');

      if (drawerInput) {
        drawerInput.value = code;
        if (drawerBody)   drawerBody.removeAttribute('hidden');
        if (drawerToggle) {
          drawerToggle.setAttribute('aria-expanded', 'true');
          drawerToggle.classList.add('fcd-discount-toggle--open');
        }
      }

      // Check if cart has items — Shopify rejects discount on an empty cart
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.item_count > 0) {
            // Cart has items — apply via the drawer's own function
            if (window.fagaciCart && window.fagaciCart.applyDiscount) {
              window.fagaciCart.applyDiscount();
            }
          } else {
            // Empty cart — store code and show a friendly pending message
            sessionStorage.setItem('fcd_discount', code);
            if (drawerMsg) {
              drawerMsg.innerHTML =
                '<span style="color:#d2ba82;font-size:11px;font-weight:600">' +
                  'Code saved — will apply when you add items.' +
                '</span>';
            }
          }
        })
        .catch(function() {
          // Fallback: try applying anyway
          if (window.fagaciCart && window.fagaciCart.applyDiscount) {
            window.fagaciCart.applyDiscount();
          }
        });

      // Open the cart drawer immediately (don't wait for the fetch)
      if (window.fagaciCart && window.fagaciCart.open) {
        window.fagaciCart.open();
      }

      // Button feedback
      copyBtn.classList.add('fpb-copied');
      btnText.textContent = '✓ Applied!';
      setTimeout(function() {
        copyBtn.classList.remove('fpb-copied');
        btnText.textContent = 'Apply Code';
      }, 2500);
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-promo-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(el) {
    var endStr = el.getAttribute('data-fpb-end');
    if (!endStr) return;
    var endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;

    var dWrap = el.querySelector('.fpb-cd-days');
    var dEl   = el.querySelector('.fpb-cd-d');
    var hEl   = el.querySelector('.fpb-cd-h');
    var mEl   = el.querySelector('.fpb-cd-m');
    var sEl   = el.querySelector('.fpb-cd-s');

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      if (dEl) dEl.textContent = pad(d);
      if (dWrap) dWrap.style.display = d > 0 ? 'inline-flex' : 'none';
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('.fpb-countdown').forEach(initCountdown);

  /* COPY CODE */
  document.querySelectorAll('.fpb-code[data-fpb-code]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.stopPropagation();
      var code = el.getAttribute('data-fpb-code');
      var original = el.textContent;
      if (!code) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function() {
          showCopied(el, original);
        }).catch(function() {
          fallbackCopy(code, el, original);
        });
      } else {
        fallbackCopy(code, el, original);
      }
    });
  });

  function showCopied(el, original) {
    var textEl = el.querySelector('.fpb-code-text') || el;
    textEl.textContent = '✔ Copied';
    el.classList.add('fpb-copied');
    setTimeout(function() {
      textEl.textContent = original;
      el.classList.remove('fpb-copied');
    }, 1800);
  }

  function fallbackCopy(code, el, original) {
    var ta = document.createElement('textarea');
    ta.value = code;
    ta.style.cssText = 'position:fixed;top:-999px;left:-999px;opacity:0;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); showCopied(el, original); } catch(e) {}
    document.body.removeChild(ta);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {

  var bar = document.getElementById('fsa-bar');
  if (!bar) return;

  var dataEl = document.getElementById('fsa-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  /* Build variant lookup map */
  var variantMap = {};
  data.variants.forEach(function (v) { variantMap[v.id] = v; });

  /* Track currently selected options */
  var curVariant = variantMap[data.currentVariantId];
  var selectedOptions = curVariant ? curVariant.options.slice() : [];

  /* ── Bar show / hide helpers ── */
  var atcHasBeenVisible = false;
  var cartIsOpen        = false;

  function showBar() {
    if (cartIsOpen) return;
    bar.classList.add('fsa-bar--visible');
    document.body.classList.add('fsa-bar-visible');
  }

  function hideBar() {
    bar.classList.remove('fsa-bar--visible');
    document.body.classList.remove('fsa-bar-visible');
  }

  /* ── Show/hide via IntersectionObserver on hero ATC ── */
  /* Show only once the shopper has scrolled DOWN past the ATC button
     (button above the viewport). When the button is on screen, or below
     it (shopper scrolled back up to the gallery), the bar stays hidden. */
  var heroAtc = document.getElementById('fph-atc');
  if (heroAtc) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        atcHasBeenVisible = true;
        hideBar();
      } else if (atcHasBeenVisible && entry.boundingClientRect.top < 0) {
        showBar();
      } else {
        hideBar();
      }
    }, { threshold: 0 }).observe(heroAtc);
  }

  /* ── Cart drawer: hide bar while cart is open ── */
  var fcdPanel = document.getElementById('fcd-panel');
  if (fcdPanel) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        cartIsOpen = fcdPanel.classList.contains('fcd-open');
        if (cartIsOpen) {
          hideBar();
        } else if (atcHasBeenVisible) {
          /* Re-show only if hero ATC is still out of view */
          var heroAtcEl = document.getElementById('fph-atc');
          if (heroAtcEl) {
            var r = heroAtcEl.getBoundingClientRect();
            if (r.bottom < 0) showBar();
          }
        }
      });
    }).observe(fcdPanel, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Apply variant data to sticky bar UI ── */
  function applyVariant(variant) {
    if (!variant) return;
    var price   = variant.price;
    var compare = variant.compare;
    var avail   = variant.available;
    var savePct = compare > price ? Math.round((compare - price) * 100 / compare) : 0;

    bar.querySelectorAll('.fsa-price').forEach(function (el) {
      el.textContent = fmtMoney(price);
    });
    bar.querySelectorAll('.fsa-compare').forEach(function (el) {
      el.textContent   = compare > price ? fmtMoney(compare) : '';
      el.style.display = compare > price ? '' : 'none';
    });
    bar.querySelectorAll('.fsa-save').forEach(function (el) {
      el.textContent   = compare > price ? 'SAVE ' + savePct + '%' : '';
      el.style.display = compare > price ? '' : 'none';
    });
    bar.querySelectorAll('.fsa-btn').forEach(function (el) {
      el.disabled    = !avail;
      el.textContent = avail ? 'Add to Cart' : 'Sold Out';
    });

    /* Update dropdown selected values */
    if (variant.options) {
      selectedOptions = variant.options.slice();
      bar.querySelectorAll('.fsa-select').forEach(function (sel) {
        var idx = parseInt(sel.dataset.optionIndex);
        if (selectedOptions[idx] !== undefined) sel.value = selectedOptions[idx];
      });
    }
  }

  /* ── Update dependent dropdowns: hide impossible options, mark OOS ── */
  function updateDependentOptions() {
    bar.querySelectorAll('.fsa-select').forEach(function (sel) {
      var idx = parseInt(sel.dataset.optionIndex);
      var currentVal = sel.value;
      var hasCurrentVal = false;

      Array.prototype.forEach.call(sel.options, function (opt) {
        var testOpts = selectedOptions.slice();
        testOpts[idx] = opt.value;

        var matching = data.variants.filter(function (v) {
          return testOpts.every(function (o, i) { return v.options[i] === o; });
        });

        if (matching.length === 0) {
          /* Impossible combination — hide the option */
          opt.hidden   = true;
          opt.disabled = true;
        } else {
          opt.hidden = false;
          var anyAvailable = matching.some(function (v) { return v.available; });
          if (!anyAvailable) {
            /* Combination exists but all OOS */
            opt.disabled = true;
            if (!opt.dataset.originalText) opt.dataset.originalText = opt.value;
            opt.text = opt.value + ' — Sold Out';
          } else {
            opt.disabled = false;
            if (opt.dataset.originalText) {
              opt.text = opt.dataset.originalText;
              delete opt.dataset.originalText;
            } else {
              opt.text = opt.value;
            }
          }
          if (opt.value === currentVal && !opt.hidden) hasCurrentVal = true;
        }
      });

      /* If current selection was hidden/invalid, pick first visible available option */
      if (!hasCurrentVal) {
        var firstValid = null;
        for (var i = 0; i < sel.options.length; i++) {
          if (!sel.options[i].hidden && !sel.options[i].disabled) {
            firstValid = sel.options[i];
            break;
          }
        }
        /* Fall back to first non-hidden even if OOS */
        if (!firstValid) {
          for (var j = 0; j < sel.options.length; j++) {
            if (!sel.options[j].hidden) { firstValid = sel.options[j]; break; }
          }
        }
        if (firstValid) {
          sel.value = firstValid.value;
          selectedOptions[idx] = firstValid.value;
        }
      }
    });
  }

  /* ── Find variant matching current selectedOptions ── */
  function findVariantByOptions(opts) {
    var found = null;
    data.variants.forEach(function (v) {
      if (found) return;
      var match = opts.every(function (o, i) { return v.options[i] === o; });
      if (match) found = v;
    });
    return found;
  }

  /* ── Trigger hero variant selector ──
     Calls JS functions directly (never .click()) to avoid focus-scroll.
     Additionally suppresses scrollIntoView on .fph-thumb elements so that
     fphGoToSlide inside applyVariantState doesn't scroll the page. ── */
  function triggerHeroVariant(variantId) {
    /* Temporarily override scrollIntoView on hero thumb elements to prevent
       fphGoToSlide from scrolling the page when triggered from the sticky bar */
    var thumbs = document.querySelectorAll('.fph-thumb');
    thumbs.forEach(function (t) { t.scrollIntoView = function () {}; });
    setTimeout(function () {
      thumbs.forEach(function (t) { delete t.scrollIntoView; });
    }, 0);

    var sw = document.querySelector('.fph-variant-swatch[data-variant-id="' + variantId + '"]');
    if (sw) {
      if (typeof window.fphSelectSwatch === 'function') { window.fphSelectSwatch(sw); } else { sw.click(); }
      return;
    }
    var vb = document.querySelector('.fph-variant-btn[data-variant-id="' + variantId + '"]');
    if (vb) {
      if (typeof window.fphSelectVariant === 'function') { window.fphSelectVariant(vb); } else { vb.click(); }
      return;
    }
    var dd = document.getElementById('fph-variant-dropdown');
    if (dd) {
      dd.value = variantId;
      if (typeof window.fphSelectDropdown === 'function') { window.fphSelectDropdown(dd); }
      else { dd.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var hi = document.getElementById('fph-form-variant-id');
    if (hi) hi.value = String(variantId);
  }

  /* ── Sticky dropdown change ── */
  bar.querySelectorAll('.fsa-select').forEach(function (select) {
    select.addEventListener('change', function () {
      syncVariant(parseInt(this.dataset.optionIndex), this.value);
    });
  });

  /* ── Sync: sticky option change → update dependent options → find variant → trigger hero ── */
  function syncVariant(optionIndex, value) {
    selectedOptions[optionIndex] = value;
    updateDependentOptions();
    var variant = findVariantByOptions(selectedOptions);
    if (variant) {
      applyVariant(variant);
      triggerHeroVariant(variant.id);
    }
  }

  /* Run once on init to hide impossible/OOS options for default variant */
  updateDependentOptions();

  /* ── Sync back: hero form change → update sticky bar ── */
  function syncBarFromMainForm() {
    var hi = document.getElementById('fph-form-variant-id');
    if (!hi) return;
    var vid = parseInt(hi.value);
    var variant = variantMap[vid];
    if (variant) applyVariant(variant);
  }

  /* Watch hero hidden input via property setter */
  var heroInput = document.getElementById('fph-form-variant-id');
  if (heroInput) {
    var _val = heroInput.value;
    try {
      Object.defineProperty(heroInput, 'value', {
        configurable: true,
        get: function ()  { return _val; },
        set: function (v) { _val = v; applyVariant(variantMap[parseInt(v)]); }
      });
    } catch (e) {}
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'value') applyVariant(variantMap[parseInt(heroInput.getAttribute('value'))]);
      });
    }).observe(heroInput, { attributes: true });
  }

  /* Also listen to change events bubbling from the main product form */
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('#fph-product-form')) {
      syncBarFromMainForm();
    }
  });

  /* ── ATC button — delegate to hero ATC ── */
  bar.querySelectorAll('.fsa-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var heroBtn = document.getElementById('fph-atc');
      if (heroBtn && !heroBtn.disabled) {
        heroBtn.click();
        bar.querySelectorAll('.fsa-btn').forEach(function (b) { b.textContent = 'Added ✓'; });
        setTimeout(function () {
          bar.querySelectorAll('.fsa-btn').forEach(function (b) {
            if (!b.disabled) b.textContent = 'Add to Cart';
          });
        }, 1800);
      }
    });
  });

  /* ── Money formatter ── */
  function fmtMoney(cents) {
    /* Format in the buyer's active currency, matching the format
       Shopify's own `money` filter renders server-side — same symbol,
       same separators — so JS-updated prices never disagree with
       Liquid-rendered ones on the same page. */
    var LOCALES = {
      EUR:'de-DE', GBP:'en-GB', AUD:'en-AU', USD:'en-US', CAD:'en-CA',
      RON:'ro-RO', PLN:'pl-PL', CZK:'cs-CZ', HUF:'hu-HU', BGN:'bg-BG',
      DKK:'da-DK', SEK:'sv-SE', NOK:'nb-NO', CHF:'de-CH', JPY:'ja-JP'
    };
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var amt = cents / 100;
    var loc = LOCALES[cur] || document.documentElement.lang || undefined;
    try {
      return new Intl.NumberFormat(loc, {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol'
      }).format(amt);
    } catch (e) {
      try {
        /* narrowSymbol is unsupported on older Safari */
        return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(amt);
      } catch (e2) {
        return amt.toFixed(2) + ' ' + cur;
      }
    }
  }


})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fagaci-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="ftm-"]').forEach(function (section) {
    var sectionId = section.id.replace('ftm-', '');
    var track     = section.querySelector('.ftm-track');
    var carousel  = section.querySelector('.ftm-carousel');
    var btnPrev   = section.querySelector('.ftm-arrow--prev');
    var btnNext   = section.querySelector('.ftm-arrow--next');
    var dotsWrap  = document.getElementById('ftm-dots-' + sectionId);

    if (!track || !carousel) return;

    var cards      = Array.from(track.children);
    var total      = cards.length;
    var current    = 0;
    var perView    = 1;
    var touchStartX = 0;
    var touchDeltaX = 0;

    function getPerView() {
      var w = window.innerWidth;
      if (w >= 1024) return 3;
      if (w >= 768)  return 2;
      return 1;
    }

    function maxIndex() {
      return Math.max(0, total - perView);
    }

    function cardWidth() {
      return cards[0] ? cards[0].offsetWidth + 2 : 0; // +2 for gap
    }

    function goTo(index) {
      current = Math.min(Math.max(index, 0), maxIndex());
      track.style.transform = 'translateX(-' + (current * cardWidth()) + 'px)';
      updateDots();
      updateArrows();
    }

    function updateArrows() {
      btnPrev.disabled = current === 0;
      btnNext.disabled = current >= maxIndex();
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var count = maxIndex() + 1;
      if (count <= 1) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.className = 'ftm-dot' + (i === 0 ? ' ftm-dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () { goTo(parseInt(this.dataset.index)); });
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.ftm-dot').forEach(function (d, i) {
        d.classList.toggle('ftm-dot--active', i === current);
      });
    }

    function init() {
      perView = getPerView();
      current = Math.min(current, maxIndex());
      buildDots();
      goTo(current);
    }

    btnPrev.addEventListener('click', function () { goTo(current - 1); });
    btnNext.addEventListener('click', function () { goTo(current + 1); });

    // Swipe
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    carousel.addEventListener('touchend', function () {
      if (Math.abs(touchDeltaX) > 50) {
        goTo(touchDeltaX < 0 ? current + 1 : current - 1);
      }
    });

    // Resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newPer = getPerView();
        if (newPer !== perView) {
          perView = newPer;
          current = Math.min(current, maxIndex());
          buildDots();
        }
        goTo(current);
      }, 150);
    });

    init();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
